/* RESPONSIBLE TEAM: team-fin-nux */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class TutorialsRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(TutorialsRoute);
